import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { withTranslation } from 'react-i18next';
import ListLinkBox from '../../../components/UI/ListLinkBox';
import { translate } from '../../../utils/util';
import BackButton from '../../../components/UI/BackButton';
import { checkPermission } from '../../../services/auth';
import { PERMISSIONS } from '../../../utils/constants';

const Storage = (props) => {

    const menu = () => {
        let menuItems = [];

        // if (checkPermission(PERMISSIONS.Warehouse_Container.Storage.Upload)) {
        //     menuItems = [...menuItems, { route: '?', icon: 'mdi mdi-location-enter', text: translate('container:storage:menu.uploadFile') }];
        // }

        if (checkPermission(PERMISSIONS.Warehouse_Container.Storage.Store)) {
            menuItems = [...menuItems, { route: 'storage/container', icon: 'mdi mdi-location-enter', text: translate('container:storage:menu.storage-container') }];
        }

        if (checkPermission(PERMISSIONS.Warehouse_Container.Storage.Register) || checkPermission(PERMISSIONS.Warehouse_Container.Storage.RegisterSearch)) {
            menuItems = [...menuItems, { route: 'config/registercontainer', icon: 'mdi mdi-location-enter', text: translate('container:config:menu.register-container') }];
        }

        // if (checkPermission(PERMISSIONS.Warehouse_Container.Storage.Ovate)) {
        //     menuItems = [...menuItems, { route: '?', icon: 'mdi mdi-location-enter', text: translate('container:storage:menu.ovar-container') }];
        // }

        if (checkPermission(PERMISSIONS.Warehouse_Container.Storage.Transfer)) {
            menuItems = [...menuItems, { route: 'storage/transfer', icon: 'mdi mdi-location-enter', text: translate('container:storage:menu.transfer-container') }];
        }

        if (checkPermission(PERMISSIONS.Warehouse_Container.Storage.UpdateStatus)) {
            menuItems = [...menuItems, { route: 'storage/changeStatus', icon: 'mdi mdi-location-enter', text: translate('container:storage:menu.change-status-container') }];
        }

        if (checkPermission(PERMISSIONS.Warehouse_Container.Storage.Dates)) {
            menuItems = [...menuItems, { route: 'storage/changeDates', icon: 'mdi mdi-calendar-month', text: translate('container:storage:menu.change-dates-container') }];
        }

        if (checkPermission(PERMISSIONS.Warehouse_Container.Storage.UpdateStatus)) {
            menuItems = [...menuItems, { route: 'storage/changeStatusList', icon: 'mdi mdi-location-enter', text: 'Listar Container' }];
        }

        if (checkPermission(PERMISSIONS.Warehouse_Container.Storage.PartNumberSupplier)) {
            menuItems = [...menuItems, { route: 'storage/partnumbersupplier', icon: 'mdi mdi-location-enter', text: 'Desenho Fornecedor x Desenho Stellantis' }];
        }




        menuItems = [...menuItems, { route: 'storage/uploadFile', icon: 'mdi mdi-location-enter', text: 'Upload De Para Embalagem' }];
        menuItems = [...menuItems, { route: 'storage/uploadContainer', icon: 'mdi mdi-location-enter', text: "Upload Container" }];

        menuItems = [...menuItems, { route: 'storage/map', icon: 'mdi mdi-location-enter', text: "Map Patio" }];

        return menuItems;
    };

    return (
        <div>
            <BackButton {...props} />
            <div className="container-fluid h-65">
                <div className="row">
                    <div className="title">
                        <i className="mdi mdi-clipboard-check-outline" />
                        {translate('container:menu.storage')}
                    </div>
                </div>
            </div>
            <div className="container" style={{ marginLeft: '5px', marginTop: '40px', }}>
                <ListLinkBox
                    options={menu()}
                />
            </div>
        </div>
    );
};

const mapStateToProps = (state) => {
    return {
        user: state.userReducer.user
    };
};

export default withRouter(connect(mapStateToProps)(withRouter(withTranslation()(Storage))));